function ensureSlickLoaded(callback) {
  const run = typeof callback === "function" ? callback : function () {};
  if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
    run();
    return;
  }

  const assets = window.themeAssets || {};
  const slickJs = assets.slickJs;
  const slickCss = assets.slickCss;
  if (!slickJs) {
    run();
    return;
  }

  if (slickCss && !document.querySelector('link[data-slick-css]')) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = slickCss;
    link.setAttribute("data-slick-css", "true");
    document.head.appendChild(link);
  }

  const existing = document.querySelector("script[data-slick-js]");
  if (existing) {
    existing.addEventListener("load", run, { once: true });
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) run();
    return;
  }

  const script = document.createElement("script");
  script.src = slickJs;
  script.defer = true;
  script.setAttribute("data-slick-js", "true");
  script.onload = run;
  script.onerror = run;
  document.head.appendChild(script);
}

function initFrequentlyBoughtSlick() {
  var start = function () {
    ensureSlickLoaded(function () {
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
      var $slider = $(".gbfrequently-bought-with-main-whole-slider");
      if (!$slider.length) return;
      if ($slider.hasClass("slick-initialized")) {
        $slider.css("opacity", "1");
        return;
      }
      $slider.slick({
        infinite: true,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
      $slider.css("opacity", "1");
    });
  };
  if (typeof window.ensureJQuery === "function") {
    window.ensureJQuery(start);
  } else {
    start();
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  startCountdownTimer() {
    const timerElement = document.getElementById("cart-countdown-timer");
    if (!timerElement) return;
    
    // Reset timer to 10 minutes
    let minutes = 10;
    let seconds = 0;
    
    // Clear any existing timer
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    
    // Update the timer display
    const updateTimer = () => {
      timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    
    // Initial display
    updateTimer();
    
    // Start the countdown
    this.countdownInterval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.countdownInterval);
          return;
        }
        minutes--;
        seconds = 59;
      } else {
        seconds--;
      }
      
      updateTimer();
    }, 1000);
  }

  open(triggeredBy) {
    const doOpen = () => {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");

    initFrequentlyBoughtSlick();
    
    // Start the countdown timer when drawer opens
    this.startCountdownTimer();
    };
    if (typeof window.ensureJQuery === "function") {
      window.ensureJQuery(doOpen);
    } else {
      doOpen();
    }
  }

  close() {
    // Check if cart customization mode is active
    const cartCustomizationMode = document.querySelector('cart-drawer').classList.contains('customization-mode');
    if (cartCustomizationMode) {
      alert('Cart Customization Mode is active. Disable it in Theme Settings > Cart Drawer to allow closing.');
      return;
    }
    
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    
    // Clear the countdown timer when drawer closes
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    initFrequentlyBoughtSlick();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    setTimeout(function () {
      initFrequentlyBoughtSlick();
    }, 500);

    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    setTimeout(function () {
      initFrequentlyBoughtSlick();
    }, 500);

    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
